import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Plant } from '../../../data/schemas/session.schema';
import { ContextService } from '../../../services/context.service';

@Component({
  selector: 'app-planta-chip',
  imports: [MatIconModule, MatMenuModule, NgTemplateOutlet],
  templateUrl: './planta-chip.component.html',
  styleUrl: './planta-chip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlantaChipComponent {
  private readonly router = inject(Router);
  protected readonly ctx = inject(ContextService);

  protected selectPlant(p: Plant): void {
    this.ctx.select(p);
    void this.router
      .navigateByUrl('/_', { skipLocationChange: true })
      .then(() => this.router.navigateByUrl('/home'));
  }
}
